import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

type TestimonialCardProps = {
    readonly image: string;
    readonly quote: string;
    readonly name: string;
    readonly title: string;
};

const cardContainerStyles = css({
    position: "relative"
});

const testimonialQuoteImageStyles = css({
    position: "absolute",
    width: "10%",
    insetInlineEnd: "-8%",
    insetBlockStart: "-11%",
    zIndex: "-1",
    [media.below.md]: {
        display: "none"
    }
});

const testimonialQuotesSectionStyles = css({
    color: "#000",
    width: "776px",
    paddingBlockEnd: "25px",
    background: "#fff",
    borderRadius: "0px var(--large-rounding, 20px)",
    display: "flex",
    [media.below.md]: {
        flexDirection: "column",
        maxWidth: "316px"
    }
});

const customerImageStyles = css({
    width: "255px",
    height: "238px",
    [media.above.lg]: {
        marginInlineStart: "-1%",
        marginBlockStart: "-1%"
    }
});

const quoteContainerStyles = css({
    width: "454px",
    marginInlineStart: "5%",
    hr: {
        width: "106px",
        height: "1px",
        color: "#6B778C",
        marginBlockStart: "16px",
        marginInlineStart: "0",
        [media.below.md]: {
            width: "43px"
        }
    },
    p: {
        ["&.quote"]: {
            fontSize: "1.25rem",
            color: "var(--Neutrals-N900, #091E42)",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "var(--bxp-charlie-display-font-family)",
            fontStyle: "normal",
            zIndex: "2",
            [media.below.md]: {
                width: "264px",
                margin: "29px, 0 0 15px",
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "0.3px",
                paddingInlineEnd: "26px"
            }
        },
        ["&.name"]: {
            fontSize: "1.2rem",
            fontWeight: 600,
            margin: 0
        },
        ["&.title"]: {
            margin: 0,
            fontSize: "20px",
            [media.below.md]: {
                color: " var(--neutral-light-n-800, #172B4D)",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "var(--atlassian-recommended-system-fonts)",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "24px",
                width: "183px"
            }
        }
    },
    [media.below.md]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingInlineEnd: "26px",
        paddingInlineStart: "26px"
    },
    [media.above.lg]: {
        marginBlockStart: "15px"
    }
});

export const TestimonialCard = ({
    image,
    quote,
    name,
    title
}: TestimonialCardProps) => {
    return (
        <div css={cardContainerStyles}>
            <img
                css={testimonialQuoteImageStyles}
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/quote.webp"
                alt="quote"
            />
            <div css={testimonialQuotesSectionStyles}>
                <img css={customerImageStyles} src={image} alt={title} />
                <div css={quoteContainerStyles}>
                    <p className="quote">“{quote}”</p>
                    <hr />
                    <p className="name">{name}</p>
                    <p className="title">{title}</p>
                </div>
            </div>
        </div>
    );
};
